import { ROLE_ENUM } from "@/constant/constants.ts";
import { useTranslation } from "react-i18next";

const CustomerStatusTag = ({ status }: { status?: number | null }) => {
  const { t } = useTranslation();

  let color = "#fafafa";
  if (status === ROLE_ENUM.ADMIN) {
    color = "#faad14";
  } else if (status === ROLE_ENUM.USER) {
    color = "#52c41a";
  }

  const USER_ROLE_MAP: Map<number, string> = new Map([
    [ROLE_ENUM.ADMIN, t("field.admin")],
    [ROLE_ENUM.USER, t("field.user")],
  ]);

  return (
    <>
      {status ? (
        <span
          key={status}
          className={"w-[111px] text-center whitespace-nowrap"}
        >
          <span style={{ color: color }}>•</span> {USER_ROLE_MAP.get(status)}
        </span>
      ) : (
        <span>-</span>
      )}
    </>
  );
};

export default CustomerStatusTag;
